import { Box, Stack } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { colors } from '~/theme';

const SPLASH_DURATION_MS = 1500;
const LOGO_WIDTH = 331;
const LOGO_HEIGHT = 123.75;
const BACKING_OFFSET = 27;

export const SplashScreen = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timeout = setTimeout(() => navigate('/boas-vindas', { replace: true }), SPLASH_DURATION_MS);
    return () => clearTimeout(timeout);
  }, [navigate]);

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      sx={{
        backgroundColor: colors.white,
        backgroundImage: 'url(/splash-texture.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        '@media (min-width: 900px)': {
          backgroundImage: 'url(/splash-texture-desktop.png)',
        },
      }}
    >
      <Box sx={{ position: 'relative', width: LOGO_WIDTH, height: LOGO_HEIGHT + BACKING_OFFSET }}>
        <Box
          sx={{
            position: 'absolute',
            top: BACKING_OFFSET,
            left: 0,
            width: LOGO_WIDTH,
            height: LOGO_HEIGHT,
            backgroundColor: colors.aliceBlue,
            borderRadius: '12px',
          }}
        />
        <Box
          component="img"
          src="/logo-validador.png"
          alt="CUB Validador de Cobranças"
          sx={{ position: 'absolute', top: 0, left: 0, width: LOGO_WIDTH }}
        />
      </Box>
    </Stack>
  );
};
